import { noop } from 'lodash';
import React, { useCallback, useState } from 'react';

import { ImprintModal, PrivacyPolicyModal } from '../components/modals';

export type ModalType = 'imprint' | 'privacyPolicy' | 'none';

interface Context {
	closeModal: () => void;
	openModal: (type: ModalType) => void;
}

const defaultContext: Context = {
	closeModal: noop,
	openModal: noop,
};

const ModalsContext = React.createContext(defaultContext);

const ModalsProvider: React.FC = (props) => {
	const [modal, setModal] = useState<ModalType>('none');

	// biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome hook deps kept as-is; changing the deps list alters effect timing
	const openModal = useCallback(
		(type: ModalType) => {
			setModal(type);
		},
		[setModal]
	);

	// biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome hook deps kept as-is; changing the deps list alters effect timing
	const closeModal = useCallback(() => {
		setModal('none');
	}, [setModal]);

	Object.assign(defaultContext, { closeModal, openModal });

	return (
		<ModalsContext.Provider value={defaultContext}>
			<ImprintModal show={modal === 'imprint'} onClose={closeModal} />
			<PrivacyPolicyModal show={modal === 'privacyPolicy'} onClose={closeModal} />
			{props.children}
		</ModalsContext.Provider>
	);
};

export { ModalsContext, ModalsProvider };
